import {
    apiRequest,
    skpnsList,
    skpnsActive,
    skpnsInactive
} from "../../../../../services/adapters/kepegawaian/skpnsService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", skpnsList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", skpnsInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", skpnsActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository